import { z } from "zod";

// Куда вернуться после входа: только путь этого же сайта. `//evil.example` и `/\evil.example`
// браузер считает другим доменом, поэтому такие адреса отбрасываются (защита от open redirect).
// Возврат на саму страницу входа тоже не нужен.
const nextPathSchema = z
  .string()
  .refine(
    (path) =>
      path.startsWith("/") &&
      !path.startsWith("//") &&
      !path.startsWith("/\\") &&
      !path.startsWith("/login"),
  );

// Код приглашения друга (`/login?ref=k3m9x2ab`): уходит в форму входа, бэкенд запишет,
// кто позвал нового игрока. Не похож на код — пропадает.
const referralCodeSchema = z.string().regex(/^[a-z0-9]{4,16}$/i);

// Search params страницы входа: `/login?next=%2Fmatches%2F42&ref=k3m9x2ab`. Неверные значения
// просто пропадают.
export const loginSearchSchema = z.object({
  next: nextPathSchema.optional().catch(undefined),
  ref: referralCodeSchema.optional().catch(undefined),
});

export type LoginSearch = z.infer<typeof loginSearchSchema>;
